module.exports = __webpack_public_path__ + "static/media/ZIM.94ad9061.svg";